/**
 * Affiche la version livree, en bas a droite de l'application.
 * La valeur est injectee au deploiement par la chaine CI/CD (SPEC-10).
 */
const VERSION = import.meta.env.VITE_APP_VERSION || 'dev'
const COMMIT = import.meta.env.VITE_APP_COMMIT || ''

const VersionFooter = () => (
  <div
    title={COMMIT ? `commit ${COMMIT.slice(0, 8)}` : undefined}
    style={{
      position: 'fixed',
      right: 8,
      bottom: 4,
      zIndex: 1,
      fontSize: 11,
      lineHeight: '14px',
      color: 'rgba(0, 0, 0, 0.35)',
      pointerEvents: 'auto',
      userSelect: 'text',
    }}
  >
    v{VERSION}
  </div>
)

export default VersionFooter
